import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M className={className} initial={{ y: 36, opacity: 0.25 }} whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}>
      {children}
    </M>
  );
};

export const Eyebrow = ({ children, n }) => (
  <p className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-[var(--mute)]">
    {n && <span className="text-[var(--red)]">{n}</span>}
    <span className="h-px w-8 bg-[var(--red)]" aria-hidden />
    {children}
  </p>
);
